export default function Brand({ light = false }: { light?: boolean }) {
  return <div className={`brand ${light ? 'brand-light' : ''}`}><span><img src="/jiumi.png" alt="九米" /></span><div><b>九米产业带</b><small>出海平台</small></div></div>
}
